/**
 * Export — three cards, one action each, and no wizard.
 *
 * A pilot arriving here has already decided what they want; the pane's whole job
 * is to make the three possible answers visible at once and get out of the way.
 * The order is the order they are wanted in: the document that goes in the
 * kneeboard, the link that goes to the instructor, the file that goes into the
 * next tool.
 *
 * At the foot, one line about what is coming. It is not a roadmap and it is not
 * a teaser: it exists so a pilot who came looking for a navigation log as a PDF
 * stops looking, instead of hunting through menus for something that is not
 * there yet.
 */

import { useT } from '../../i18n';
import { FileCard } from './FileCard';
import { PdfCard } from './PdfCard';
import { ShareCard } from './ShareCard';
import './export.css';

export function ExportPane() {
  const t = useT();
  return (
    <div className="aex">
      <PdfCard />
      <ShareCard />
      <FileCard />

      <section className="aex-soon">
        <h2 className="ae-eyebrow">{t('export.soon.title')}</h2>
        <p className="aex-line">{t('export.soon.line')}</p>
        <ul>
          <li>{t('export.soon.navlog')}</li>
          <li>{t('export.soon.fpl')}</li>
          <li>{t('export.soon.wx')}</li>
        </ul>
      </section>
    </div>
  );
}

export default ExportPane;
